import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  Button,
  Checkbox,
  TextField,
  DialogContent,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContentText,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseBankTerminals } from "./UseBankTerminals";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { useSnackbar } from "notistack";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function BankTerminals() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getBankTerminals, UpdateBankTerminals } = UseBankTerminals();

  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });

  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [banksRes, setBankRes] = useState();
  const [openAdd, setOpenAdd] = useState(false);
  const [mobileState, setMobileState] = useState("");
  const [checked, setChecked] = useState([]);

  const [openDetail, setOpenDetail] = useState({
    show: false,
    mobile: undefined,
  });

  useEffect(() => {
    setProgress(true);
    getBankTerminals((Banks) => {
      setBankRes(Banks);
    }, true);
  }, []);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "index",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "bankName",
      headerName: "نام درگاه",
      width: 200,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.bankName}
          </Typography>
        );
      },
    },
    {
      field: "enable",
      headerName: "وضعیت",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.enable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 180,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  index: cellValues.row.index - 1,
                  enable: cellValues.row.enable,
                };
                if (cellValues.row.index - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  UpdateBankTerminals(model, () => {
                    getBankTerminals((Banks) => {
                      setBankRes(Banks);
                    }, false);
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  index: cellValues.row.index + 1,
                  enable: cellValues.row.enable,
                };

                if (cellValues.row.index + 1 == banksRes.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  UpdateBankTerminals(model, () => {
                    getBankTerminals((Banks) => {
                      setBankRes(Banks);
                    }, false);
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
            <Box sx={{ ml: 1 }}>
              {cellValues.row.enable ? (
                <Button
                  onClick={() => {
                    setOpenDialog({
                      show: true,
                      model: {
                        id: cellValues.row.id,
                        bankName: cellValues.row.bankName,
                        enable: false,
                        index: cellValues.row.index,
                      },
                    });
                  }}
                  variant="contained"
                  color="error"
                >
                  غیرفعال
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    setOpenDialog({
                      show: true,
                      model: {
                        id: cellValues.row.id,
                        bankName: cellValues.row.bankName,
                        enable: true,
                        index: cellValues.row.index,
                      },
                    });
                  }}
                  variant="contained"
                >
                  فعال
                </Button>
              )}
            </Box>
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/bankterminals",
          },
        ],
      }}
    >
      {" "}
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از{" "}
            {openDialog.show && !openDialog.model.enable ? "غیرفعال" : "فعال"}{" "}
            کردن درگاه اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              UpdateBankTerminals(openDialog.model, () => {
                getBankTerminals((Banks) => {
                  setOpenDialog({ ...openDialog, show: false });
                  setBankRes(Banks);
                }, false);
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      {banksRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={banksRes ? banksRes : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={banksRes.length ? banksRes.length : "1"}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              nofab: true,
              isLtr: true,
              // nofab: true,
              rowCount: banksRes && banksRes.length ? banksRes.length : "",
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
